import { withProcedureWraper } from "../../../../..";
import { Error, Loading } from "../../../../../../../components";
import ProcedureLayout from "../../../../../../../components/layouts/procedure-layout";
import { CreateSickLeaveForm } from "../../../components/create-sick-leave-form";
import { useAFLRequest } from "../../../hooks";
const dataFallback = {};

export const SickLeaveEdit = withProcedureWraper(() => {
  const { data = dataFallback, isLoading: isRequestLoading, isFetching: isRequestFetching, isError } = useAFLRequest();

  if (isRequestLoading) return <Loading />;
  if (isError) return <Error description="Không tìm thấy dữ liệu" />;

  return (
    <ProcedureLayout title="Chỉnh sửa đơn xin nghỉ ốm/nuôi con ốm" loading={isRequestFetching}>
      <CreateSickLeaveForm data={data} />
    </ProcedureLayout>
  );
});
